import { component } from 'picoapp';
import { changeItem } from 'lib/cart';  // eslint-disable-line

export default component((node, ctx) => {
  /**
   * Data + elements
   */
  const config = JSON.parse(node.dataset.config);
  const { key, quantity } = config;

  const qtyDecreaseBtn = node.querySelector('.js-qtyDecreaseBtn');
  const qtyIncreaseBtn = node.querySelector('.js-qtyIncreaseBtn');
  const removeBtn = node.querySelector('.js-removeBtn');

  /**
   * Functions
   */
  const decreaseQty = () => {
    changeItem({
      key,
      quantity: parseInt(quantity, 10) - 1,
    });
  };

  const increaseQty = () => {
    ctx.emit('cart:disable');
    changeItem({
      key,
      quantity: parseInt(quantity, 10) + 1,
    });
  };

  const remove = () => {
    changeItem({
      key,
      quantity: 0,
    });
  };

  const init = () => {
    qtyDecreaseBtn.addEventListener('click', (event) => {
      event.preventDefault();
      decreaseQty();
    });

    qtyIncreaseBtn.addEventListener('click', (event) => {
      event.preventDefault();
      increaseQty();
    });
    removeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      remove();
    });
  };

  /**
   * Init
   */
  init();
});
